import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MediatorsListComponent } from './mediators-list/mediators-list.component';
import { MediatorsDetailComponent } from './mediators-detail/mediators-detail.component';

const routes: Routes = [
    {
        path: 'mediators',
        children: [
            { path: '', component: MediatorsListComponent },
            { path: ':id', component: MediatorsDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MediatorsRoutingModule { }
